module.exports = __webpack_public_path__ + "img/idejian.cbdd82d0.png";